import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ttb2n52ngz: FaireBrandEntity = {
  token: "b_ttb2n52ngz",
  type: "brand",
  name: "BeNat",
  avatarUrl:
    "https://cdn.faire.com/fastly/074346e6e82899710ebf97da1dbdf329432ba5fa434b73b78779e55a2c75655c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aeca07c856357ad8c0a04c4dbf974b8ed6e237133475d596cb35be6da5618092.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/074346e6e82899710ebf97da1dbdf329432ba5fa434b73b78779e55a2c75655c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aeca07c856357ad8c0a04c4dbf974b8ed6e237133475d596cb35be6da5618092.jpeg",
  location: "Fort Lauderdale, FL, USA",
  minimumOrderDollars: 111,
  rating: 4.5,
  reviewCount: 55,
  isInsider: true,
  description:
    "At BeNat, we are on a mission to constantly innovate for our customers, one awesome product at a time. Established in Florida founded by a mom of 3, who wants the best for her kids, families, and planet. We are passionate about promoting healthy, natural, and eco-friendly choices for those who care about the environment and are looking for simple, clean, and effective personal care & beauty products that are great for you and good for our planet. Our products are made with all-natural ingredients in small batches with care and love!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.982Z",
    importedBy: "entity-db-cli",
  },
};
